export const modalContentTypes = 
    {
        walletHome: 'walletHome',
        walletNotDetected: 'walletNotDetected'
    }
